import { Divider, Flex } from "antd";
import { FormattedMessage } from "react-intl";
import type { UserOrganization } from "~types/userOrganization";
import type { StartupItem } from "../../types/startupItem";

const transformUserOrganization = (organization: UserOrganization): StartupItem => ({
  id: organization.organizationId,
  title: organization.nameLocal,
  subtitle: (
    <Flex align="center">
      <FormattedMessage id="organization.id" values={{ organizationId: organization.organizationId }} />
      <Divider type="vertical" />
      <span>{organization.sport}</span>
    </Flex>
  ),
});

export default transformUserOrganization;
